<!--
<div class="level1-tabs">
  <button
    *ngFor="let tab of level1Tabs"
    [ngClass]="'tab_' + tab"
    [class.active]="selectedType === tab"
    (click)="selectType(tab)">
    {{ level1Labels[tab] }}
  </button>
</div>
-->
<div class="menu-holder">
  <div class="tiles-container">
    @for (group of groups; track group) {
      <div
        class="tile"
        [class.active]="selectedGroup?.id === group.id"
        [attr.role]="'button'"
        [attr.tabindex]="0"
        [attr.aria-pressed]="selectedGroup?.id === group.id"
        [attr.aria-label]="group.title + (selectedGroup?.id === group.id ? ' - wybrany' : '')"
        (click)="selectGroup(group)"
        (keydown.enter)="selectGroup(group)"
        (keydown.space)="selectGroup(group); $event.preventDefault()"
        [title]="group.title">
        @if (group.icon) {
          <mat-icon aria-hidden="true">{{ group.icon }}</mat-icon>
        }
        <span class="tile-title">{{ group.title }}</span>
      </div>
    }
  </div>
</div>